import React, { useEffect, useMemo } from 'react';
import Modal from '../Modal/index';
import styles from './index.module.scss';
export default (props) => {
    const { msg, duration = 1500, visible, hideToast } = props;
    const content = useMemo(() => {
        return React.createElement("div", { className: styles['toast-container'] + ' ' + 'tst-name' }, msg);
    }, [msg]);
    useEffect(() => {
        if (!visible)
            return;
        setTimeout(() => {
            hideToast();
        }, duration);
    }, [visible]);
    return React.createElement(Modal, { visible: visible, containerStyle: { pointerEvent: 'none', backgroundColor: 'transparent' }, content: content, hideModal: () => {
            hideToast();
        } });
};
